import Keycloak from "keycloak-js"
const keycloak = new Keycloak({
    url: process.env.REACT_APP_KEYCLOAK_URL,
    realm: process.env.REACT_APP_KEYCLOAK_REALM,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

// Add event listeners
/*keycloak.onAuthSuccess = () => {
    keycloak.loadUserInfo().then((userInfo) => {
        console.log(userInfo)
        // store.dispatch(setUser(userInfo));
    });
};

keycloak.onAuthLogout = () => {
    console.log("logout")

    // store.dispatch(clearUser());
};

keycloak.onTokenExpired = () => {
    keycloak.updateToken(30).then((refreshed) => {
        console.log(refreshed)

        if (refreshed) {
            keycloak.loadUserInfo().then((userInfo) => {
                console.log(userInfo)

                // store.dispatch(setUser(userInfo));
            });
        } else {
            console.warn("Token refresh failed");
        }
    }).catch(() => {
        console.error("Failed to refresh token");
    });
};*/

// Initialize Keycloak
// keycloak
//     .init({ onLoad: "check-sso" })
//     .then((authenticated) => {
//         if (authenticated) {
//             keycloak.loadUserInfo().then((userInfo) => {
//                 console.log(userInfo)
//
//                 // store.dispatch(setUser(userInfo));
//             });
//         }
//     })
//     .catch((error) => {
//         console.error("Keycloak initialization failed", error);
//     });

export default keycloak;
